import * as amap from '@/api/amap'
import * as marker from '@/api/marker'

const poiSearch = {
  state: {
    searchParams: {},
    searchResult: {},
    poi2Marker: {}
  },
  mutations: {
    SET_SEARCH_PARAMS: (state, data) => {
      state.searchParams = data
    },
    SET_SEARCH_RESULT: (state, data) => {
      state.searchResult = data
    },
    SET_POI2MARKER: (state, data) => {
      if (!data) {
        state.poi2Marker = {}
      } else {
        state.poi2Marker = data
      }
    }
  },
  actions: {
    // poi搜索
    poiSearch ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        amap.poiSearch(data).then(response => {
          if (response.code === 200) {
            commit('SET_SEARCH_RESULT', response.data)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 标注搜索
    markerSearch ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        marker.searchMarkers(data).then(response => {
          if (response.code === 200) {
            commit('SET_SEARCH_RESULT', response.data)
            resolve(response)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 清除搜索结果
    clearSearch ({ commit, state, getters }, data) {
      return new Promise((resolve, reject) => {
        resolve()
      })
    }
  }
}

export default poiSearch
